import styled from 'styled-components'
import { TituloH1 as TituloPrincipal, Descricao } from '../../../../components/TituloSorriso/styles'
import { colorBrandPrimary } from '../../../../global.style'
import { media } from '../../../../layouts/utils'

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  background-color: ${colorBrandPrimary.turquoise};
  height: 350px;
  ${media.phone`
    height: fit-content;
  `}
`

export const Container = styled.div`
  ${media.phone`
    display: block;
    width: 100%;
    padding: 5px;
    margin: 0;
    text-align: center;
  `}
  display: flex;
  width: 80%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  justify-content: center;
  `

export const TextWrap = styled.div`
  padding: 20px 20px 20px 56px;
  ${media.phone`
    padding:20px;
  `}
`

export const Title = styled(TituloPrincipal)`
  ${media.desktop`
    text-align: start;
    max-width: 100%;
  `}
  ${media.phone`
    text-align: center;
    font-size: 32px;
  `}
  color: ${(props) => props.color};
  text-align: left;
  max-width: 300px;
  line-height: 14px;
  margin-bottom: 32px;
  font-weight: bold;
`

export const Text = styled(Descricao)`
  ${media.phone`
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
    text-align: center;
  `}
  color: ${(props) => props.color};
  text-align: left;
  max-width: 440px;
  line-height: 24px;
`

export const Image = styled.img`
  ${media.desktop`
    text-align: left;
    width: 50%;
    height: 42%;
    margin-top: 15px;
  `}
  ${media.phone`
    display: none;
  `}
  height: 140px;
`
export const ButtonTag = styled.button` 
  min-width: 104px;
  height: 49px;
  font-size: 1rem;
  font-weight: bold;
  transition: all 0.1s ease-in 0s;
  border-radius: 99px;
  text-align: center;
  margin-top: 54px;
  color:${(props) => props.color};
  background-color:${(props) => props.background};

  &:hover {
    min-width: 106px;
    margin-right: -0.5rem;
    transition: 0.2s;
    transform: translateY(-0.25rem);
  }

  ${media.wide`
    margin-top: 32px;
  `}
  
`